import React, { useState, useEffect} from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import InfoTooltip from "./InfoTooltip";
import './TaggingPage.css';
import Tutorial from './Tutorial';


function TaggingPage() {
    const navigate = useNavigate();

    //Commented for Mturk
    // const { state, search } = useLocation();
    // const params = new URLSearchParams(search);
    // const pid = params.get('pid') || state?.pid || 'unknown';
    // const scenario = state?.scenario || params.get('scenario') || 'unknown';

    // MTurk-safe location + query parsing
    const location = useLocation();
    const qs = new URLSearchParams(location.search);
    const navState = location.state || {};           // SAFE container instead of destructuring

    const pid = qs.get('pid') || navState.pid || 'unknown';
    const scenario = navState.scenario || qs.get('scenario') || 'unknown';

    // For MTurk finished page
    const assignmentId =
        qs.get('assignmentId') ||
        qs.get('assignment_id') ||
        '';

    const turkSubmitTo =
        qs.get('turkSubmitTo') ||
        qs.get('turk_submit_to') ||
        '';


    // For Mturk finished page
    // const params = new URLSearchParams(window.location.search);
    // const assignmentId = params.get('assignmentId');
    // const turkSubmitTo = params.get('turkSubmitTo');



    // const creationDuration = state?.creationDuration;
    const creationDuration = navState.creationDuration;
    const [showTutorial, setShowTutorial] = useState(false);


    const poemDraft = navState.poemDraft || '';
    // Draft text passed in via state
    // const poemDraft = state?.poemDraft || '';


    // const withSearch = (extra = {}) => {
    //     const sp = new URLSearchParams(search || '');
    //     Object.entries(extra).forEach(([k, v]) => {
    //         if (v === undefined || v === null) sp.delete(k);
    //         else sp.set(k, String(v));
    //     });
    //     return `?${sp.toString()}`;
    // };

    //Mturk one
    const withSearch = (extra = {}) => {
        const sp = new URLSearchParams(location.search || '');
        Object.entries(extra).forEach(([k, v]) => {
            if (v === undefined || v === null) sp.delete(k);
            else sp.set(k, String(v));
        });
        return `?${sp.toString()}`;
    };


    // Rating metrics
    const [metrics, setMetrics] = useState({
        mental_image: 3,
        flow: 3,
        intended_mood: 3,
        originality: 3,
    });

    // Primary Mood dropdown
    const [primaryMood, setPrimaryMood] = useState('Joyful');
    const [dropdowns, setDropdowns] = useState({ primaryMood: false });
    const toggleDropdown = (name) =>
        setDropdowns((prev) => ({ ...prev, [name]: !prev[name] }));

    const [inspiration, setInspiration] = useState('');


    const primaryMoodOptions = [
        'Joyful','Melancholy','Energetic','Inspirational',
        'Love','Calm','Political','Sarcastic','Fearful'
    ];

    // Labels & dialogues...
    const mentalImageLabels = ['Very Poorly','Poorly','Neutral','Well','Very Well'];
    const mentalImageDialogues = [
        "I can't visualize anything at all.",
        "Only vague or partial images.",
        "Some images come to mind, but not strongly.",
        "Clear and fairly detailed images.",
        "Extremely vivid; I can see it clearly."
    ];
    const flowLabels = ['Very Bad','Bad','Neutral','Good','Very Good'];
    const flowDialogues = [
        "Very difficult to read; feels jarring or disjointed.",
        "Somewhat difficult to follow; has awkward transitions.",
        "Average flow; neither smooth nor difficult.",
        "Reads smoothly with good transitions.",
        "Exceptionally smooth reading experience; perfect rhythm."
    ];
    const intendedMoodLabels = ['Very Off','Off','Neutral','On','Very On'];
    const intendedMoodDialogues = [
        "Completely misses the intended emotional tone.",
        "Somewhat misaligned with the intended mood.",
        "Moderately aligned with the intended mood.",
        "Well aligned with the intended emotional tone.",
        "Perfectly captures the intended mood and emotion."
    ];
    const originalityLabels = ['Very Unoriginal','Unoriginal','Neutral','Original','Very Original'];
    const originalityDialogues = [
        "Very derivative; feels like I've seen it many times before.",
        "Somewhat conventional with few original elements.",
        "Moderately original with some fresh elements.",
        "Quite original with fresh perspective or approach.",
        "Exceptionally unique and innovative."
    ];

    const handleMetricChange = (field, value) =>
        setMetrics((prev) => ({ ...prev, [field]: value }));

    // Submit & then return to the editor (preserve scenario in query + state)
    // const handleSubmit = async () => {
    //     try {
    //         const payload = {
    //             poem_text: poemDraft,
    //             mental_image: metrics.mental_image,
    //             flow: metrics.flow,
    //             intended_mood: metrics.intended_mood,
    //             originality: metrics.originality,
    //             primary_mood: primaryMood,
    //             inspiration: inspiration,
    //             scenario: scenario,
    //             pid: pid,
    //             creationDuration: creationDuration,
    //             // summary if in use...
    //         };
    //         // console.log('test',payload);
    //         // const res = await axios.post(
    //         //     'http://127.0.0.1:5001/api/tagged_poems',
    //         //     payload
    //         // );
    //         // if (res.data.message) {
    //         //     navigate(`/write-poem?interface=write&type=editor&scenario=${scenario}`, {
    //         //         state: { poemDraft, scenario }
    //         //     });
    //         // }
    //         // // deployed endpoints (uncomment as needed):
    //         // const res = await axios.post('http://140.238.156.35:5001/api/tagged_poems', payload);
    //         const res = await axios.post('/api/tagged_poems', payload);
    //         // if (res.data.message) {
    //         //   navigate(`/write-poem?interface=write&type=editor&scenario=${scenario}`, {
    //         //     state: { poemDraft, scenario }
    //         //   });
    //         // }
    //         if (res.data.message){
    //             navigate('/')
    //         }
    //     } catch (err) {
    //         console.error('Error creating tagged poem:', err);
    //         alert('Error submitting tagged poem. Check console.');
    //     }
    // };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const workerId =
            qs.get('workerId') ||
            qs.get('worker_id') ||
            '';

        const assignmentId =
            qs.get('assignmentId') ||
            qs.get('assignment_id') ||
            '';

        const hitId =
            qs.get('hitId') ||
            qs.get('hit_id') ||
            '';

        const payload = {
            poem_text: poemDraft,
            mental_image: metrics.mental_image,
            flow: metrics.flow,
            intended_mood: metrics.intended_mood,
            originality: metrics.originality,
            primary_mood: primaryMood || null,
            inspiration: inspiration || null,
            scenario: scenario,
            pid: pid,
            creation_duration: creationDuration,
            worker_id: workerId || null,
            assignment_id: assignmentId || null,
            hit_id: hitId || null,
        };

        try {
            const response = await fetch('/api/tagged_poems', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                const data = await response.json().catch(() => ({}));
                const sp = new URLSearchParams(location.search || '');
                sp.set('interface', 'write');   // ScenarioFeedbackPage uses this

                navigate({
                    pathname: `/feedback/${encodeURIComponent(scenario)}`,
                    search: `?${sp.toString()}`
                });
            } else {
                alert('Error publishing poem');
            }
        } catch (error) {
            console.error('Error:', error);
            alert('Error publishing poem');
        }
    };


    // Return without saving
    const handleReturnToEditor = () => {
        navigate(
            { pathname: '/write-poem', search: withSearch({ interface: 'write', type: 'editor' }) },
            { state: { poemDraft, scenario } }
        );
    };

    return (
        <div className="tagging-page-container">
            <div className="left-column">
                <button
                    onClick={() => setShowTutorial(true)}
                    className="tutorial-button"
                >
                    Tutorial
                </button>
                {showTutorial && (
                    <Tutorial
                        inline
                        onClose={() => setShowTutorial(false)}
                        mode="write"
                        type="tagging"
                        scenario={scenario}   // if you want contextual slides
                    />
                )}

                <div className="final-poem-box">
                    <h3>Final Poem</h3>
                    <div className="poem-content">{poemDraft}</div>
                </div>
            </div>

            <div className="right-column">
                <h3 className="panel-title">Tagging Options</h3>

                {/* Mental Image */}
                <div className="metric-section">
                    <div className="metric-header">
                        <span className="metric-title">Mental Image</span>
                        <InfoTooltip>
                            Measures how vividly the poem paints pictures in your mind.
                        </InfoTooltip>
                    </div>
                    <p>How well does the poem create mental image?</p>
                    <div className="button-group">
                        {mentalImageLabels.map((label, idx) => {
                            const rating = idx + 1;
                            return (
                                <button
                                    key={`mi-${rating}`}
                                    className={`rating-button ${
                                        metrics.mental_image === rating ? 'selected' : ''
                                    }`}
                                    onClick={() =>
                                        handleMetricChange('mental_image', rating)
                                    }
                                >
                                    {label}
                                </button>
                            );
                        })}
                    </div>
                    <div className="dialogue-container">
                        <p>{mentalImageDialogues[metrics.mental_image - 1]}</p>
                    </div>
                </div>

                {/* Flow */}
                <div className="metric-section">
                    <div className="metric-header">
                        <span className="metric-title">Flow</span>
                        <InfoTooltip>
                            Assesses how smoothly the poem’s rhythm and pacing flow aloud.
                        </InfoTooltip>
                    </div>
                    <p>How smoothly does it read?</p>
                    <div className="button-group">
                        {flowLabels.map((label, idx) => {
                            const rating = idx + 1;
                            return (
                                <button
                                    key={`flow-${rating}`}
                                    className={`rating-button ${
                                        metrics.flow === rating ? 'selected' : ''
                                    }`}
                                    onClick={() => handleMetricChange('flow', rating)}
                                >
                                    {label}
                                </button>
                            );
                        })}
                    </div>
                    <div className="dialogue-container">
                        <p>{flowDialogues[metrics.flow - 1]}</p>
                    </div>
                </div>

                {/* Intended Mood */}
                <div className="metric-section">
                    <div className="metric-header">
                        <span className="metric-title">Intended Mood</span>
                        <InfoTooltip>
                            How clearly the poem conveys its chosen emotion.
                        </InfoTooltip>
                    </div>
                    <p>How aligned is it with the intended mood?</p>
                    <div className="button-group">
                        {intendedMoodLabels.map((label, idx) => {
                            const rating = idx + 1;
                            return (
                                <button
                                    key={`im-${rating}`}
                                    className={`rating-button ${
                                        metrics.intended_mood === rating ? 'selected' : ''
                                    }`}
                                    onClick={() =>
                                        handleMetricChange('intended_mood', rating)
                                    }
                                >
                                    {label}
                                </button>
                            );
                        })}
                    </div>
                    <div className="dialogue-container">
                        <p>{intendedMoodDialogues[metrics.intended_mood - 1]}</p>
                    </div>
                </div>

                {/* Originality */}
                <div className="metric-section">
                    <div className="metric-header">
                        <span className="metric-title">Originality</span>
                        <InfoTooltip>
                            Judges how fresh and unique the phrasing and imagery are.
                        </InfoTooltip>
                    </div>
                    <p>How unique does the poem feel?</p>
                    <div className="button-group">
                        {originalityLabels.map((label, idx) => {
                            const rating = idx + 1;
                            return (
                                <button
                                    key={`orig-${rating}`}
                                    className={`rating-button ${
                                        metrics.originality === rating ? 'selected' : ''
                                    }`}
                                    onClick={() =>
                                        handleMetricChange('originality', rating)
                                    }
                                >
                                    {label}
                                </button>
                            );
                        })}
                    </div>
                    <div className="dialogue-container">
                        <p>{originalityDialogues[metrics.originality - 1]}</p>
                    </div>
                </div>

                {/* Primary Mood */}
                <div className="metric-section">
                    <p className="metric-title">Primary Mood</p>
                    <div className="dropdown-container">
                        <div
                            className="dropdown-select"
                            onClick={() => toggleDropdown('primaryMood')}
                        >
                            {primaryMood} <span>▼</span>
                        </div>
                        {dropdowns.primaryMood && (
                            <div className="dropdown-options">
                                {primaryMoodOptions.map((opt) => (
                                    <div
                                        key={opt}
                                        className="dropdown-option"
                                        onClick={() => {
                                            setPrimaryMood(opt);
                                            toggleDropdown('primaryMood');
                                        }}
                                    >
                                        {opt}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>

                {/* Source of Inspiration */}
                <div className="metric-section">
                    <div className="metric-header">
                        <span className="metric-title">Source of Inspiration</span>
                        <InfoTooltip>
                            A guiding word or phrase that represents your poem’s idea.
                        </InfoTooltip>
                    </div>
                    <input
                        type="text"
                        className="inspiration-input"
                        placeholder="Enter a word or phrase…"
                        value={inspiration}
                        onChange={e => setInspiration(e.target.value)}
                    />
                </div>

                {/* Buttons */}
                <div className="tagging-buttons">
                    <button
                        onClick={handleReturnToEditor}
                        className="return-editor-button"
                    >
                        ← Return to Editor
                    </button>
                    <button
                        onClick={handleSubmit}
                        className="submit-button"
                    >
                        Submit &amp; Publish
                    </button>
                </div>
            </div>
        </div>
    );
}

export default TaggingPage;
